
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 116 90"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"115","height":"89","x":".5","y":".5","fill":"#FFF","stroke":"#E0E4EC","rx":"4"}}),_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('path',{attrs:{"fill":"#C1C8D6","d":"M31.263 48.758c2.075 14.766 15.728 25.055 30.495 22.98 14.766-2.076 25.055-15.73 22.98-30.496-2.076-14.766-15.73-25.055-30.496-22.98-14.766 2.076-25.055 15.73-22.98 30.496zm1.98-.279c-1.921-13.672 7.605-26.314 21.278-28.236 13.672-1.921 26.314 7.605 28.236 21.278 1.921 13.672-7.605 26.314-21.278 28.236-13.672 1.921-26.314-7.605-28.236-21.278z"}}),_c('path',{attrs:{"fill":"#0C3454","d":"M30.768 48.827c2.113 15.04 16.02 25.52 31.06 23.405 15.04-2.113 25.518-16.02 23.404-31.06-2.113-15.04-16.02-25.518-31.06-23.404l.418 2.97c13.4-1.883 25.788 7.453 27.672 20.852 1.883 13.4-7.453 25.788-20.852 27.672-13.4 1.883-25.788-7.453-27.672-20.852l-2.97.417z"}}),_c('path',{attrs:{"fill":"#05B5E4","d":"M87.708 40.825c-2.306-16.407-17.476-27.839-33.883-25.533l1.113 7.922c12.032-1.69 23.157 6.692 24.848 18.724l7.922-1.113z"}})]),_c('rect',{attrs:{"width":"15","height":"6","x":"86","y":"16","fill":"#C0C8D7","rx":"1"}}),_c('rect',{attrs:{"width":"15","height":"6","x":"81","y":"68","fill":"#C0C8D7","rx":"1"}}),_c('rect',{attrs:{"width":"15","height":"6","x":"13","y":"22","fill":"#C0C8D7","rx":"1"}})])])
          )
        }
      }
    